//Action here

import { hqiUmApiInstance, hqiSemanticApiInstance, hqiMiddlewareApiInstance } from "../service/apiInstance";
import { ErrorLog } from "../service/ErrorLog";
import { ACTIVATE_LOADER,DEACTIVATE_LOADER ,SET_USER_INFO, SET_USER_INFO_KEY_VALUE, RESET_NAVIGATION_TO_HOME, SET_ACTIVE_KNOWLEDGE_ID, SET_ACTIVE_APP, SET_PROJECT_CONFIG, SET_FUNCTIONS_AND_GOALS, SET_ROLE_LIST } from "./app.type";
import { TTYD_3 } from "../constants/Constantsi18";
import { BUSINESS_ANALYST_ROLE } from "../constants/constant";

type BrandLogo = { url: string; width: number | null; height: number | null };

const setLoader = (dispatch: any, active: boolean) => {
  if (typeof dispatch === 'function') {
    dispatch({
      type: active ? ACTIVATE_LOADER : DEACTIVATE_LOADER,
      payload: active,
    });
  }
};

export const setUserinfo = (data:any) => async (dispatch:any) => {
  dispatch({
    type: SET_USER_INFO,
    payload: data,
  });
};

export const resetNavigationToHome = () => (dispatch:any) => {
  dispatch({
    type: RESET_NAVIGATION_TO_HOME,
    payload: {},
  });
};



export const authenticateToken =
  (userFirstName: String, userLastName: String) => async (dispatch: any, getState: any) => {
    try {
      let token = localStorage.authentication;

      const response = await hqiUmApiInstance.post('login', {
        authentication: token,
        type: 'hqi',
        regenerate: false
      });
       if (response?.data?.status == '200') {

      if (response?.data?.data?.status === true) {
        let jwt_token = response?.data?.data?.access_token;
        let parsed_jwt: any
        try {
          parsed_jwt = JSON.parse(atob(jwt_token.split(".")[1]));
        } catch (parseError) {
          // console.error("Failed to parse JWT", parseError);
          throw parseError;
        }
        dispatch(setUserinfo({
          ...parsed_jwt,
          company_data: response?.data?.data?.company_data,
          userProfile: response?.data?.data?.userProfile,
          userPortfolios: response?.data?.data?.userPortfolios,
        })
        );

        localStorage.setItem('access_token', response?.data?.data?.access_token);
        localStorage.setItem('refresh_token', response?.data?.data?.refresh_token);
        
         dispatch(fetchProfileData());
      } else {
          dispatch(
            setUserinfo({
              first_name: userFirstName,
              last_name: userLastName,
            })
          );
        }
      } else {
        setLoader(dispatch, false);
        dispatch(
        setUserinfo({
          first_name: userFirstName,
          last_name: userLastName,
          is_maintenance_mode: true
        })
      );
      }
    }
    catch (error) {
      setLoader(dispatch, false);
      dispatch(
        setUserinfo({
          first_name: userFirstName,
          last_name: userLastName,
        })
      );
    }
  };




export const saveLoginData = async (
  dispatch: any,
  loginData: {
    preferredCompany: string;
    preferredProfile: string;
    preferredProject: string;
  },
  skipLoginCall: boolean = false,
  showLoader:boolean = true
)  => {
  showLoader && setLoader(dispatch, true);
  try {
    const saveLoginDataPayload = {
      company_id: loginData?.preferredCompany,
      profile_id: loginData?.preferredProfile,
      project_id: loginData?.preferredProject,
    };
    
    const response = await hqiUmApiInstance.post("loginInfo", saveLoginDataPayload);
    if (response?.data?.status === '200' || response?.status === 200) {
      dispatch((_dispatch: any, getState: any) => {
        const userId = getState()?.loginResource?.id;
        _dispatch(fetchUserGroupsList(loginData?.preferredProject));
        _dispatch(fetchUserGroupOfUser(userId));
      });

      // If not skipping login call, proceed with login API
      if (!skipLoginCall) {
        await callLoginApi(dispatch);
      }
      showLoader && setLoader(dispatch, false);
      return response.data;
    }
    
  } catch (error) {
    showLoader && setLoader(dispatch, false);
     ErrorLog("saveLoginDataApi", error);
   
  }
};

// Separate function to call login API
export const callLoginApi = async (dispatch: any, getState?: any, regenerate: boolean = false) => {
  try {
    let token = localStorage.authentication;
    
    const response = await hqiUmApiInstance.post('login', {
      authentication: token,
      type: 'hqi',
      regenerate: regenerate
    });
    
    if (response?.data?.status == '200' && response?.data?.data?.status === true) {
      let jwt_token = response?.data?.data?.access_token;
      let parsed_jwt: any;
      
      try {
        parsed_jwt = JSON.parse(atob(jwt_token.split(".")[1]));
      } catch (parseError) {
        throw parseError;
      }
      
      dispatch(setUserinfo({
        ...parsed_jwt,
        company_data: response?.data?.data?.company_data,
        userProfile: response?.data?.data?.userProfile,
        userPortfolios: response?.data?.data?.userPortfolios
      }));

      localStorage.setItem('access_token', response?.data?.data?.access_token);
      localStorage.setItem('refresh_token', response?.data?.data?.refresh_token);

      // If getState is available, fetch domains and call connection config for business analyst
      if (getState) {
        const state = getState();
        const userInfo = state.loginResource;
        
        // Fetch domain data to get active knowledge ID
        await dispatch(fetchDomainData());
        
        // Get updated state with activeKnowledgeId
        const updatedState = getState();
        const activeKnowledgeId = updatedState.loginResource?.activeKnowledgeId;
        
        // Call connection config if user is business analyst
        if (activeKnowledgeId) {
          await callConnectionConfig(userInfo, activeKnowledgeId);
        }
      }
      
      return response.data;
    }
    
  } catch (error) {
    ErrorLog("loginApi", error);
  }
};

// Combined function for company/workspace changes
export const saveLoginDataWithLogin = async (
  dispatch: any,
  loginData: {
    preferredCompany: string;
    preferredProfile: string;
    preferredProject: string;
  },
  regenerate: boolean = false
) => {
  // First call loginInfo API
  const loginInfoResponse = await saveLoginData(dispatch, loginData, true, false); // Skip login call in saveLoginData
  
  if (loginInfoResponse) {
    // Then call login API (pass regenerate parameter)
    await callLoginApi(dispatch, undefined, regenerate);
  }
  
  return loginInfoResponse;
};


// Helper function to fetch domain data and get active knowledge ID (without Redux dispatch)
export const fetchAndGetActiveKnowledgeId = async (projectId: number) => {
  try {
    const response = await hqiSemanticApiInstance.get(`knowledge_store/project/${projectId}/domains`);
    
    if (response?.data?.status === '200' || response?.status === 200) {
      const activeDomain = response.data.response.find((domain: any) => domain.is_active);
      return activeDomain?.knowledge_store_id || null;
    }
    return null;
  } catch (error) {
    ErrorLog("fetchAndGetActiveKnowledgeId", error);
    return null;
  }
};

// Fetch project config (including thinking mode and brand logos and API version) for a given project
export const fetchProjectConfig = async (dispatch: any, projectId: number) => {
  const setBrandLogos = (large: BrandLogo | null, small: BrandLogo | null) => {
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'brandLogoLarge', value: large } });
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'brandLogoSmall', value: small } });
  };

  const defaultConfig = { isThinkingModeEnabled: false, apiVersionName: 'V1' };
  try {
    if (!projectId) {
      dispatch({ type: SET_PROJECT_CONFIG, payload: defaultConfig });
      setBrandLogos(null, null);
      return;
    }

    const response = await hqiUmApiInstance.get(`project/${projectId}`);

    if (response?.data?.status === 200 || response?.status === 200) {
      const data = response.data?.data;
      const isThinkingEnabled = data?.is_thinking_mode_enabled ?? false;
      const apiVersionName = response.data?.data?.version_name ?? 'V1';
      dispatch({ type: SET_PROJECT_CONFIG, payload: { isThinkingModeEnabled: isThinkingEnabled, apiVersionName } });
      setBrandLogos(
        data?.full_logo_url
          ? { url: data.full_logo_url, width: data.full_logo_width, height: data.full_logo_height }
          : null,
        data?.small_logo_url
          ? { url: data.small_logo_url, width: data.small_logo_width, height: data.small_logo_height }
          : null,
      );
    } else {
      dispatch({ type: SET_PROJECT_CONFIG, payload: defaultConfig });
      setBrandLogos(null, null);
    }
  } catch (error) {
    ErrorLog("fetchProjectConfig", error);
    dispatch({ type: SET_PROJECT_CONFIG, payload: defaultConfig });
    setBrandLogos(null, null);
  }
};

// Fetch full list of usergroups for a project
export const fetchUserGroupsList = (projectId: any) => async (dispatch: any) => {
  if (!projectId) {
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'userGroupList', value: null } });
    return;
  }

  try {
    const response = await hqiUmApiInstance.get(`project/${projectId}/usergroups/list`);
    //const response = await hqiUmApiInstance.get(`project/331/usergroups/list`);

    dispatch({
      type: SET_USER_INFO_KEY_VALUE,
      payload: {
        key: 'userGroupList',
        value: (response?.data?.status === '200' || response?.status === 200)
          ? (response?.data?.data ?? response?.data?.response ?? null)
          : null,
      },
    });
  } catch (error) {
    ErrorLog("fetchUserGroupsList", error);
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'userGroupList', value: null } });
  }
};

// Fetch which usergroup a specific user belongs to
export const fetchUserGroupOfUser = (userId: any) => async (dispatch: any) => {
  if (!userId) {
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'userGroupMapping', value: null } });
    return;
  }

  try {
    const response = await hqiUmApiInstance.get(`user/${userId}/usergroup`);
    //const response = await hqiUmApiInstance.get(`user/98/usergroup`);

    dispatch({
      type: SET_USER_INFO_KEY_VALUE,
      payload: {
        key: 'userGroupMapping',
        value: (response?.data?.status === '200' || response?.status === 200)
          ? (response?.data?.data ?? response?.data?.response ?? null)
          : null,
      },
    });
  } catch (error) {
    ErrorLog("fetchUserGroupOfUser", error);
    dispatch({ type: SET_USER_INFO_KEY_VALUE, payload: { key: 'userGroupMapping', value: null } });
  }
};

// Fetch domains and set active knowledge ID
export const fetchDomainData = () => async (dispatch: any, getState: any) => {
  setLoader(dispatch, true);
  try {
    const state = getState();
    const projectId = state.loginResource?.preferredProject;
    
    if (!projectId) {
      dispatch({ type: SET_ACTIVE_KNOWLEDGE_ID, payload: null });
      // setLoader(dispatch, false);
      return;
    }

    const response = await hqiSemanticApiInstance.get(`knowledge_store/project/${projectId}/domains`);
    const responseApp = await hqiMiddlewareApiInstance.get(`apps/project/${projectId}`);

    if (responseApp?.data?.status === '200' || responseApp?.status === 200) {
      const activeApp = responseApp.data.response.find((apps: any) => apps.is_active);
      dispatch({
        type: SET_ACTIVE_APP,
        payload: activeApp || null
      });
    } else {
      dispatch({ type: SET_ACTIVE_APP, payload: null });
    }

    
    if (response?.data?.status === '200' || response?.status === 200) {
      const activeDomain = response.data.response.find((domain: any) => domain.is_active);
      dispatch({
        type: SET_ACTIVE_KNOWLEDGE_ID,
        payload: activeDomain?.knowledge_store_id || null
      });
    } else {
      dispatch({ type: SET_ACTIVE_KNOWLEDGE_ID, payload: null });
    }
  } catch (error) {
    ErrorLog("fetchDomainDataApi", error);
    dispatch({ type: SET_ACTIVE_KNOWLEDGE_ID, payload: null });
    dispatch({ type: SET_ACTIVE_APP, payload: null });
  } finally {
    // setLoader(dispatch, false);
  }
};

// Role master list used to populate the onboarding/profile role dropdown.
// Not project scoped, so it is fetched once per session at bootstrap.
export const fetchRoles = () => async (dispatch: any) => {
  try {
    const response = await hqiUmApiInstance.get('role');
    if (response?.data?.status === '200' || response?.status === 200) {
      dispatch({
        type: SET_ROLE_LIST,
        payload: response.data?.data ?? [],
      });
    }
  } catch (error) {
    ErrorLog("fetchRoles", error);
  }
};

export const fetchProfileData = () => async (dispatch: any, getState: any) => {
       setLoader(dispatch, true);
  try {
    const response = await hqiUmApiInstance.get("profile");  
    if (response?.data?.status === '200' || response?.status === 200) {
      
         dispatch({
        type: SET_USER_INFO_KEY_VALUE,
        payload: {
          key: 'profileData',
          value: response?.data?.data,
        },
      });

      // Role master for the profile dropdown — loaded here so it is ready
      // before Home mounts and survives company/workspace switches.
      dispatch(fetchRoles());

      //After successful profile fetch, call saveLoginData with Redux data
      const state = getState();
      const loginData = {
        preferredCompany: state.loginResource?.preferredCompany || '',
        preferredProfile: state.loginResource?.preferredProfile || '',
        preferredProject: state.loginResource?.preferredProject || '',
      };
      
      if (loginData.preferredCompany && loginData.preferredProfile && loginData.preferredProject) {
       // Use skipLoginCall = true here since this is initial app load and login was already called
       await saveLoginData(dispatch, loginData, true);

       // Fetch domain data to get active knowledge ID
       await dispatch(fetchDomainData());

       // Fetch project config for thinking mode
       await fetchProjectConfig(dispatch, loginData.preferredProject);

       // Get updated state with activeKnowledgeId
       const updatedState = getState();
       const userInfo = updatedState.loginResource;
       const activeKnowledgeId = updatedState.loginResource?.activeKnowledgeId;

       // Call connection config if user is business analyst
       if (activeKnowledgeId) {
         await callConnectionConfig(userInfo, activeKnowledgeId);
       }

       setLoader(dispatch, false);
      
      }
    } 
  } catch (error) {
    // Error case - log error
     ErrorLog("fetchProfileDataApi", error);
      setLoader(dispatch, false);
  }
};

// Helper function to get team name
const getTeamName = (userInfo: any) => {
  try {
    if (!userInfo?.company_data || !userInfo?.preferredCompany || !userInfo?.preferredProject) {
      return TTYD_3;
    }

    // Find the preferred company
    const company = userInfo.company_data.find((company: any) => 
      company.companyId === userInfo.preferredCompany
    );
    
    if (!company) {
      return TTYD_3;
    }

    // Get the project identifier (handle both array and single value cases)
    const projectIdentifier = Array.isArray(userInfo.preferredProject) 
      ? userInfo.preferredProject[0]?.project_name || userInfo.preferredProject[0]
      : userInfo.preferredProject;

    // Find the project in the company's project list
    const project = company.projectList?.find((project: any) => 
      project.project_id === projectIdentifier || 
      project.project_name === projectIdentifier
    );

    if (!project) {
      return TTYD_3;
    }

    // Return the team name (assuming it's project.project_name or project.team_name)
    const teamName = project.team_name || project.project_name || project.project_id;

    return teamName;
    
  } catch (error) {
    return TTYD_3;
  }
};

// Helper function to check if user is business analyst
const isBusinessAnalystProfile = (userInfo: any) => {
  try {
    if (!userInfo?.profileData || !userInfo?.preferredProfile) {
      return false;
    }

    const profile = userInfo.profileData.find((item: any) => item.id == userInfo.preferredProfile);
    
    if (!profile) {
      return false;
    }

    return profile.name.toLowerCase() === BUSINESS_ANALYST_ROLE;
  } catch (error) {
    return false;
  }
};

export const fetchFunctionsAndGoals = () => async (dispatch: any) => {
  try {
    const response = await hqiUmApiInstance.get('dropdowndata/functions_and_goals');
    if (response?.data?.status === '200' || response?.status === 200) {
      dispatch({
        type: SET_FUNCTIONS_AND_GOALS,
        payload: response.data.response ?? response.data.data ?? null,
      });
    }
  } catch (error) {
    ErrorLog("fetchFunctionsAndGoals", error);
  }
};

// API call for connection config when user is business analyst
export const callConnectionConfig = async (userInfo: any, activeKnowledgeId: any) => {
  try {
    if (!isBusinessAnalystProfile(userInfo)) {
      return;
    }

    if (!userInfo?.preferredProject || !activeKnowledgeId) {
      // console.warn('Missing required parameters for connection config API');
      return;
    }

    const projectId = userInfo.preferredProject;
    const knowledgeId = activeKnowledgeId;
    const teamName = getTeamName(userInfo);

    const response = await hqiMiddlewareApiInstance.post(
      `/gen-ai/connection_config/projectid/${projectId}/knowledgeid/${knowledgeId}`,
      { tenant: teamName }
    );

    if (response?.data?.status === '200' || response?.status === 200) {
      // console.log('Connection config API called successfully');
    }

    return response;
  } catch (error) {
    ErrorLog("callConnectionConfig", error);
  }
};